import { createFileRoute, Outlet } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { exerciseCategoriesQueryOptions } from "src/state/exerciseCategories";
import { exerciseMovementPatternsQueryOptions } from "src/state/exerciseMovementPatterns";
import { exerciseMuscleGroupsQueryOptions } from "src/state/exerciseMuscleGroups";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/exercises")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb({ params }) {
      return {
        href: `/orgs/${params.slug}/exercises`,
        labelTranslationKey: "exercisesPage.breadcrumb",
      };
    },
  },
  async loader({ context }) {
    return loaderHandler(async () => {
      await Promise.all([
        context.queryClient.query({
          ...exerciseCategoriesQueryOptions(),
          staleTime: "static",
        }),
        context.queryClient.query({
          ...exerciseMuscleGroupsQueryOptions(),
          staleTime: "static",
        }),
        context.queryClient.query({
          ...exerciseMovementPatternsQueryOptions(),
          staleTime: "static",
        }),
      ]);

      return { data: null };
    });
  },
});

function RouteComponent() {
  return <Outlet />;
}
